/**
 * @fileoverview POST handler for the "/engagement/content_blocks/duplicate" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementContentBlocksDuplicateCacheKeys } from "./constants";
import type { EngagementContentBlocksDuplicateResult } from "./types";

export const postEngagementContentBlocksDuplicate = reactQueryMutationAdapter(
  engagementContentBlocksDuplicateCacheKeys,
  (ids: string[]): Promise<EngagementContentBlocksDuplicateResult> => {
    return fetch("/engagement/content_blocks/duplicate", "POST", {
      ids,
    });
  }
);
